// extracted by mini-css-extract-plugin
export default {"graphik":"Graphik_graphik__zKvfq"};